import { render } from "./CreateCustomTheme.vue?vue&type=template&id=6f033860&scoped=true&ts=true"
import script from "./CreateCustomTheme.vue?vue&type=script&lang=ts"
export * from "./CreateCustomTheme.vue?vue&type=script&lang=ts"

import "./CreateCustomTheme.vue?vue&type=style&index=0&id=6f033860&scoped=true&lang=css"

import exportComponent from "D:\\ventla-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f033860"]])

export default __exports__